import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import store from './redux/store';
import initCookieBanner from './service/CookieBanner';

import './assets/sass/main.scss';
import * as serviceWorker from './serviceWorker';
import Navigation from './navigation';
import './index.scss';

const environment = process.env.NODE_ENV;
if (environment !== 'development') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.5,
    environment: process.env.NODE_ENV,
  });
}

initCookieBanner();

ReactDOM.render(
  <div className="root-container">
    <Provider store={store}>
      <Navigation />
    </Provider>
  </div>,
  document.getElementById('root'),
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
